import React from 'react';
export default () => (
  <div className='container'>
    <h3>Unauthorized</h3>
    <p>You don’t have permissions to see this resource</p>
  </div>
);
